import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { UsersService } from '../users.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationMessageService } from '../../shared/notification-message/notification-message.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';

@Component({
	selector: 'app-edit-access-functions',
	templateUrl: './edit-access-functions.component.html',
	styleUrls: ['./edit-access-functions.component.css']
})
export class EditAccessFunctionsComponent implements OnInit {

	userId: number;
	accessOptions: any[];
	boolAccessOptions: any[];
	accessOptionsToAdd: any[] = [];
	newAccessFunction: any = {};
	accessFunctions: any = {};
	userInfo: any = {};
	userAccessFunctions: any = {};
	docAccessFunction;
	selectedAccessFunctionToAdd: string[] = [];
	selectedAccessFunctionToRemove: string[] = [];

	@ViewChild("confirmUpdateUserAccessFunction") confirmUpdateUserAccessFunction: ModalComponent;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private translateService: TranslateService,
		private notificationMessage: NotificationMessageService,
		private usersService: UsersService,
		private sideMenuService: SideMenuService,
		private commonService: CommonService
	) { }

	ngOnInit() {
		this.sideMenuService.hide();
		this.accessOptions = [
			{'id': 'read', 'text': this.translateService.instant('g.read')},
			{'id': 'write', 'text': this.translateService.instant('g.write')}
		];
		
		this.boolAccessOptions = [
			{'id': 'yes', 'text': this.translateService.instant('g.yes')},
			{'id': 'no', 'text': this.translateService.instant('g.no')}
		];
		
		this.route.params.subscribe( (params: any) => {
			this.userId = Number(params.userId);

			this.getUserAccessFunctions();
		});
	}

	getKeys(obj) {
		return Object.keys(obj);
	}

	goBack() {
		this.router.navigate(['/admin-panel/users']);
	}

	editAccessFunction(mode, data) {
		
		if(mode == 'del') {

			var functionKey = data;
			delete this.userAccessFunctions[functionKey];

			// add removed access function to list of available access functions
			this.accessOptionsToAdd.push(functionKey);
			return;
		}

		//mode == 'add'
		var functionKey = data.key;
		
		// remove added access function from list of available access functions
		let idx = this.accessOptionsToAdd.indexOf(functionKey);

		if(idx != -1)
			this.accessOptionsToAdd.splice(idx, 1)
		
		this.userAccessFunctions[functionKey] = data.access;
		
		this.newAccessFunction = {};
	};

	getUserAccessFunctions() {
		
		if(!this.userId)
			return;
		
		this.usersService.getUserAccessFunctions(this.userId).subscribe((data:any) => {
			this.accessFunctions = data.access_functions_data;
			this.userAccessFunctions = data.access_functions;
			this.userInfo = data.userInfo;
			this.commonService.setPageTabTitle(`${this.translateService.instant('users.edit_user_access_functions')} - ${this.userInfo.first_name} ${this.userInfo.last_name}`);
			let accessOptionsToAdd = [];

			for(let func in this.accessFunctions) {
				if(!this.userAccessFunctions.hasOwnProperty(func))
					accessOptionsToAdd.push(func)

				if(!this.accessFunctions[func].hasReadOption && this.userAccessFunctions.hasOwnProperty(func)){
					if(this.userAccessFunctions[func] == 'write')
						this.userAccessFunctions[func] = 'yes';
					else
						this.userAccessFunctions[func] = 'no';
				}
			}

			this.accessOptionsToAdd  = accessOptionsToAdd.map((item) => ({'label': this.translateService.instant("access_func."+item), 'value': item}));
			this.accessOptionsToAdd = this.commonService.sortDataAlphabetically(this.accessOptionsToAdd, 'label');
		});
	}

	ngAfterViewInit() {
		this.confirmUpdateUserAccessFunction.onClose.subscribe((ok) => {
			if (ok)
				return this.updateUserAccessFunctions();
			else
				return this.confirmUpdateUserAccessFunction.hide();
		});
	}

	checkUserAccessFunctionBeforeUpdate() {
		if ('user_login_disable' in this.userAccessFunctions)
			return this.confirmUpdateUserAccessFunction.show();
		return this.updateUserAccessFunctions();
	}

	updateUserAccessFunctions() {
		let tempAccess = {};
		for(let func in this.userAccessFunctions) {
			tempAccess[func] = this.userAccessFunctions[func];
			if(this.userAccessFunctions[func] == 'yes')
				tempAccess[func] = 'write';
			if(this.userAccessFunctions[func] == 'no')
				tempAccess[func] = '';
		}

		this.usersService.updateUserAccessFunctions(this.userId, tempAccess).subscribe((data) => {
			this.notificationMessage.setMessage('globalSuccessMsg');
			this.goBack();
		});
	}

	removeAllUserAccessFunctions() {
		for (const fn of Object.keys(this.userAccessFunctions)) {
			delete this.userAccessFunctions[fn];
			this.accessOptionsToAdd.push({ label: this.translateService.instant('access_func.'+fn), value: fn});
		}
	}

	assignAllAccessFunctionToUser() {
		for (const fn of this.accessOptionsToAdd) {
			this.userAccessFunctions[fn.value] = 'yes';
		}
		this.accessOptionsToAdd = [];
	}

	removeSelectedAccessFunctionFromUser() {
		for (const fn of this.selectedAccessFunctionToRemove) {
			delete this.userAccessFunctions[fn];
			this.accessOptionsToAdd.push({ label: this.translateService.instant('access_func.'+fn), value: fn})
		}
		this.selectedAccessFunctionToRemove = [];
	}

	addSelectedAccessFunctionToUser() {
		for (const fn of this.selectedAccessFunctionToAdd) {
			this.userAccessFunctions[fn] = 'yes';
			this.accessOptionsToAdd = this.accessOptionsToAdd.filter(fun => fun.value != fn);
		}
		this.selectedAccessFunctionToAdd = [];
	}
}